<nz-form-item>
  <nz-form-control [nzValidateStatus]="onValidation ? 'validating' : errorType" [nzErrorTip]="errorMessage">
    <nz-switch class="mb-3 mr-3" [(ngModel)]="value" [nzDisabled]="disabled" (ngModelChange)="inputChanged()"
      nzCheckedChildren="Si" nzUnCheckedChildren="No" [disabled]="disabled">
    </nz-switch>
  </nz-form-control>
</nz-form-item>